/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ItemsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create an item with optional barcodes and SKUs
     * @returns any Item created
     * @throws ApiError
     */
    public createItem({
        requestBody,
    }: {
        requestBody?: {
            name: string;
            description?: string;
            skus?: Array<string>;
            barcodes?: Array<string>;
        },
    }): CancelablePromise<{
        id: string;
        name: string;
        description?: string;
        skus: Array<string>;
        sku_count: number;
        barcodes: Array<string>;
        barcode_count: number;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/items',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Owner role required`,
                409: `Barcode or SKU already exists`,
            },
        });
    }
    /**
     * List items
     * @returns any Item list
     * @throws ApiError
     */
    public getItems(): CancelablePromise<Array<{
        id: string;
        name: string;
        description?: string;
        skus: Array<string>;
        sku_count: number;
        barcodes: Array<string>;
        barcode_count: number;
        created_at: string;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/items',
            errors: {
                401: `Authentication required`,
            },
        });
    }
    /**
     * Search items by name, barcode, or ID
     * @returns any Matching items
     * @throws ApiError
     */
    public searchItems({
        q,
    }: {
        q: string,
    }): CancelablePromise<Array<{
        id: string;
        name: string;
        description?: string;
        skus: Array<string>;
        barcodes: Array<string>;
        total_quantity: number;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/items/search',
            query: {
                'q': q,
            },
            errors: {
                401: `Authentication required`,
            },
        });
    }
    /**
     * Get an item
     * @returns any Item details
     * @throws ApiError
     */
    public getItem({
        id,
    }: {
        id: string,
    }): CancelablePromise<{
        id: string;
        name: string;
        description?: string;
        skus: Array<string>;
        sku_count: number;
        barcodes: Array<string>;
        barcode_count: number;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/items/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Authentication required`,
                404: `Item not found`,
            },
        });
    }
    /**
     * Delete an item
     * @returns void
     * @throws ApiError
     */
    public deleteItem({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/items/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Owner role required`,
                404: `Item not found`,
                409: `Item has movement history`,
            },
        });
    }
    /**
     * Update item name and/or description
     * @returns any Updated item
     * @throws ApiError
     */
    public updateItem({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: {
            name?: string;
            description?: string;
        },
    }): CancelablePromise<{
        id: string;
        name: string;
        description?: string;
        skus: Array<string>;
        sku_count: number;
        barcodes: Array<string>;
        barcode_count: number;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/items/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Owner role required`,
                404: `Item not found`,
            },
        });
    }
    /**
     * Add a barcode to an item
     * @returns any Updated item
     * @throws ApiError
     */
    public addBarcode({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: {
            barcode: string;
        },
    }): CancelablePromise<{
        id: string;
        name: string;
        description?: string;
        skus: Array<string>;
        sku_count: number;
        barcodes: Array<string>;
        barcode_count: number;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/items/{id}/barcodes',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Owner role required`,
                404: `Item not found`,
                409: `Barcode already exists`,
            },
        });
    }
    /**
     * Add a SKU to an item
     * @returns any Updated item
     * @throws ApiError
     */
    public addSku({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: {
            sku: string;
        },
    }): CancelablePromise<{
        id: string;
        name: string;
        description?: string;
        skus: Array<string>;
        sku_count: number;
        barcodes: Array<string>;
        barcode_count: number;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/items/{id}/skus',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Owner role required`,
                404: `Item not found`,
                409: `SKU already exists`,
            },
        });
    }
    /**
     * Remove a SKU from an item
     * @returns void
     * @throws ApiError
     */
    public deleteItemSku({
        id,
        sku,
    }: {
        id: string,
        sku: string,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/items/{id}/skus/{sku}',
            path: {
                'id': id,
                'sku': sku,
            },
            errors: {
                403: `Owner role required`,
                404: `Item or SKU not found`,
            },
        });
    }
    /**
     * Remove a barcode from an item
     * @returns void
     * @throws ApiError
     */
    public deleteItemBarcode({
        id,
        barcode,
    }: {
        id: string,
        barcode: string,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/items/{id}/barcodes/{barcode}',
            path: {
                'id': id,
                'barcode': barcode,
            },
            errors: {
                403: `Owner role required`,
                404: `Item or barcode not found`,
            },
        });
    }
    /**
     * Get item inventory balance across warehouses
     * @returns any Item balance
     * @throws ApiError
     */
    public getItemBalance({
        id,
    }: {
        id: string,
    }): CancelablePromise<{
        item_id: string;
        item_name: string;
        warehouses: Array<{
            warehouse_id: string;
            warehouse_name: string;
            total_quantity: number;
            bins: Array<{
                bin_id: string;
                bin_name: string;
                quantity: number;
            }>;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/items/{id}/balance',
            path: {
                'id': id,
            },
            errors: {
                401: `Authentication required`,
                404: `Item not found`,
            },
        });
    }
    /**
     * Get movement history for an item
     * @returns any Item movements
     * @throws ApiError
     */
    public getItemMovements({
        id,
        limit = 100,
        offset,
    }: {
        id: string,
        limit?: number,
        offset?: number | null,
    }): CancelablePromise<{
        total: number;
        movements: Array<{
            movement_id: string;
            type: 'ADD' | 'REMOVE' | 'TRANSFER' | 'COUNT_ADJUSTMENT' | 'MANUAL_ADJUSTMENT';
            timestamp: string;
            user_id: string;
            user_name: string;
            quantity: number;
            source_warehouse_id?: string;
            source_warehouse_name?: string;
            dest_warehouse_id?: string;
            dest_warehouse_name?: string;
            source_bin_id?: string;
            source_bin_name?: string;
            dest_bin_id?: string;
            dest_bin_name?: string;
            note?: string;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/items/{id}/movements',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Authentication required`,
                404: `Item not found`,
            },
        });
    }
}
